module.exports = __webpack_public_path__ + "static/featuredBlockLayout1Front-be7e64f293dd8c5c16fbfc9db1622a79.png";